import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { key: 0 }


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseOutput',
  props: {
  label: String,
  unit: String,
  result: Number,
  classType: String,
},
  setup(__props) {

const props = __props;



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(__props.classType)
  }, [
    _createElementVNode("label", null, _toDisplayString(__props.label) + " ", 1),
    _createElementVNode("p", null, [
      _createElementVNode("b", null, [
        _createTextVNode(_toDisplayString(__props.result), 1),
        (((__props.result > 0) && (__props.unit)))
          ? (_openBlock(), _createElementBlock("span", _hoisted_1, " " + _toDisplayString(__props.unit), 1))
          : _createCommentVNode("", true)
      ])
    ])
  ], 2))
}
}

})